import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { MedicationList } from "@pages/AdminDashboard/ui/MedicationList";
import { UiKitSection } from "@pages/AdminDashboard/ui/UiKitSection";
import { MedicationInclusion, OrderMedicationsState } from "@types-runway/admin";

const [spaceXs, , spaceMd, , spaceXl] = adminTokens.spacing;

const medication = (
  caseOfferingId: string,
  name: string,
  directions: string,
  inclusion: MedicationInclusion
) => ({ caseOfferingId, name, directions, inclusion });

const sent = (first: MedicationInclusion, second: MedicationInclusion): OrderMedicationsState => ({
  status: "loaded",
  medications: [
    medication("co-test-0001", "Acetazolamide 125 mg", "Take 1 tablet by mouth twice daily", first),
    medication("co-test-0002", "Azithromycin 500 mg", "Take 1 tablet by mouth once daily", second),
  ],
});

const examples: { name: string; medications: OrderMedicationsState }[] = [
  { name: "Included and not included", medications: sent("included", "not_included") },
  { name: "Not sent yet", medications: sent("not_sent", "not_sent") },
  { name: "Unknown", medications: sent("unknown", "unknown") },
  { name: "Loading", medications: { status: "pending" } },
  { name: "None", medications: { status: "loaded", medications: [] } },
  { name: "Couldn't load", medications: { status: "failed" } },
];

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(360px, 100%), 1fr));
  gap: ${spaceMd}px;
  margin-bottom: ${spaceXl}px;
`;

const Example = styled.div.attrs({ role: "group" })`
  display: flex;
  flex-direction: column;
  gap: ${spaceXs}px;
  border: 1px solid ${adminTokens.color.border};
  border-radius: ${adminTokens.radius.row}px;
  padding: ${spaceMd}px;
`;

const Caption = styled.span`
  color: ${adminTokens.color.inkSoft};
  font-family: ${adminTokens.typeScale.meta.fontFamily};
  font-size: ${adminTokens.typeScale.meta.fontSize};
`;

// The medications list with every mark and every state, each under its own label (MEDS-R5,
// MEDS-R7, UIKIT-R8).
export const MedicationListSection = () => (
  <UiKitSection title="Medication list">
    <Grid>
      {examples.map(({ name, medications }) => (
        <Example key={name} aria-label={name}>
          <Caption>{name}</Caption>
          <MedicationList medications={medications} />
        </Example>
      ))}
    </Grid>
  </UiKitSection>
);
